import { makeAutoObservable, runInAction } from "mobx";

export class MachinelogState {
  reloadData: boolean = false;

  reload() {
    runInAction(() => {
      this.reloadData = !this.reloadData;
    });
  }
  constructor() {
    makeAutoObservable(this);
  }
}
